import { connect, MapDispatchToProps } from "react-redux";
import LoginComponent, { LoginProps } from "pages/Login";
import { loginRequest } from "store/auth/actions";
import { ILogin, ILoginContainerDispatch } from "utils/interfaces/login";
import { checkValidReCaptchaRequest } from "store/studentEnrolment/actions";

const mapDispatchToProps: MapDispatchToProps<ILoginContainerDispatch, ILogin> =
  {
    loginRequest,
    checkValidReCaptchaRequest,
  };

const connector = connect(null, mapDispatchToProps);

const Login: React.FC<LoginProps> = (props) => {
  return <LoginComponent {...props} />;
};

export default connector(Login);
